import { ProjectClusterDto } from '@cradua/data';
import { createAction, props } from '@ngrx/store';

/**
 * Load Countries Collection Actions
 */
export const loadProjectCluster = createAction(
  '[ProjectCluster] Load ProjectCluster'
);

export const loadProjectClusterSuccess = createAction(
  '[ProjectCluster] Load ProjectCluster Success',
  props<{ projectCluster: ProjectClusterDto[] }>()
);

export const loadProjectClusterFailure = createAction(
  '[ProjectCluster] Load ProjectCluster Failure',
  props<{ error: any }>()
);

/**
 * Add Project to Collection Actions
 */
export const addProjectCluster = createAction(
  '[ProjectCluster] Add ProjectCluster',
  props<{ newProjectCluster: ProjectClusterDto[] }>()
);

export const addProjectClusterSuccess = createAction(
  '[ProjectCluster] Add ProjectCluster Success',
  props<{ newProjectCluster: ProjectClusterDto[] }>()
);

export const addProjectClusterFailure = createAction(
  '[ProjectCluster] Add ProjectCluster Failure',
  props<{ error: any }>()
);

/**
 * Search for record Collection Actions
 */
export const searchProjectClusterRecord = createAction(
  '[ProjectCluster] Search  ProjectCluster Record',
  props<{ query: string }>()
);

/**
 * Update ProjectCluster Collection Actions
 */
export const updateProjectCluster = createAction(
  '[ProjectCluster] Update ProjectCluster',
  props<{ updateProjectCluster: ProjectClusterDto[] }>()
);

export const updateProjectClusterSuccess = createAction(
  '[ProjectCluster] Update ProjectCluster Success',
  props<{ updateProjectCluster: ProjectClusterDto[] }>()
);

export const updateProjectClusterFailure = createAction(
  '[ProjectCluster] Update ProjectCluster Failure',
  props<{ error: any }>()
);

/**
 * Remove ProjectCluster Collection Actions
 */
export const removeProjectCluster = createAction(
  '[ProjectCluster] Remove ProjectCluster',
  props<{ ids: string[] }>()
);

export const removeProjectClusterSuccess = createAction(
  '[ProjectCluster] Remove ProjectCluster Success',
  props<{ ids: string[] }>()
);

export const removeProjectClusterFailure = createAction(
  '[ProjectCluster] Remove ProjectCluster Failure',
  props<{ error: any }>()
);
